module.exports = __webpack_public_path__ + "static/media/logo-lunch-team.a98c15c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-lunch-team.svg
// module id = 75
// module chunks = 5